<template>
  <div style="width: 100%;">
    <v-card class="roma-card-inline">
      <v-row class="hidden-sm-and-down">
        <v-col align="center" class="hidden-md-and-down col-lg-2 col-xl-2">
          <img src="@/assets/images/image-poll.png" alt="" />
        </v-col>
        <v-col class="col-md-8 col-sm-12 col-lg-8 col-xl-8">
          <span class="roma-card-inline__sub-header pt-8 ml-3">{{
            polls.medicionTO.code
          }}</span>
          <h1 class="roma-card-inline__title ml-3">
            {{ polls.medicionTO.name }}
          </h1>
        </v-col>
        <v-col class="col-md-2 col-sm-12 col-lg-2 col-xl-2">
          <span class="roma-card-inline__sub-header-right" v-if="getMa === polls.idMedicionAsignada">En Proceso</span>
          <span class="roma-card-inline__sub-header-right" v-else>Por Realizar</span>
          <button class="text-capitalize" :class="disable ? 'btn-disable' : 'btn-start'" @click="startPoll(polls)" :disabled="disable">
            <span v-if="!disable">
              <span v-if="getMa === polls.idMedicionAsignada">Continuar</span>
              <span v-else>Iniciar</span>
            </span>
            <span v-else>Procesando...</span>
          </button>
        </v-col>
      </v-row>

      <v-row class="hidden-md-and-up">
        <v-col align="center" cols="12" class="pa-0 ma-0">
          <span class="roma-card-inline__sub-header-right" v-if="getMa === polls.idMedicionAsignada">En Proceso</span>
          <span class="roma-card-inline__sub-header-right" v-else>Por Realizar</span>
        </v-col>
        <v-col class="col-md-12 col-sm-12" cols="12">
          <span class="roma-card-inline__sub-header pt-8 ml-3">{{
            polls.medicionTO.code
          }}</span>
          <h1 class="roma-card-inline__title ml-3">
            {{ polls.medicionTO.name }}
          </h1>
        </v-col>
        <v-col class="col-sm-12">
          <button id="search" class="text-capitalize" :class="disable ? 'btn-disable' : 'btn-start'" @click="startPoll(polls)" :disabled="disable">
            <span v-if="!disable">
              <span v-if="getMa === polls.idMedicionAsignada">Continuar</span>
              <span v-else>Iniciar</span>
            </span>
            <span v-else>Procesando...</span>
          </button>
        </v-col>
      </v-row>
    </v-card>
    <RomaNoAvailable
      v-if="noAvailable"
      :message="message"
      :position="positionMessage"
      class="mt-5"
    ></RomaNoAvailable>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from "vuex";
import RomaNoAvailable from "@/components/commons/RomaNoAvailable";

export default {
  props: ["polls"],
  name: "RomaCardPoll",
  data() {
    return {
      noAvailable: false,
      message: null,
      positionMessage: null,
      disable: false
    };
  },
  created(){
    this.$nextTick(() => {
      document.getElementById('search').classList.remove('v-btn--disabled')
    })
  },
  components: {
    RomaNoAvailable,
  },
  computed: {
    ...mapGetters({
      getMa: "getMA"
    }),
  },
  methods: {
    ...mapActions({
      setPoll: "setPoll",
      setQuantityQuestions: "setQuantityQuestions",
      setQuestions: "setQuestion",
      setUrlPDF: "setUrlPDF",
      setMa: "setMa",
      setPollDone: "setPollDone",
      setLoadedPdf: "setLoadedPdf",
      setCarouselIndex: "setCarouselIndex"
    }),
      startPolls(data){
        this.disable = true;
        if(this.getMa === data.idMedicionAsignada) {
          this.$router.push({path: `/encuesta/${data.idMedicionAsignada}`});
          this.setPollDone({pollDone: false});
          this.disable = false;
        } else {
          this.setPoll({poll: data});
          this.setQuantityQuestions({
            quantityQuestions: data.medicionTO.quantityQuestions,
          })
          this.setMa({idMedicionAsignada: data.idMedicionAsignada});
          this.setQuestions({questions: data.medicionTO.form.questions});
          this.$router.push({path: `/encuesta/${data.idMedicionAsignada}`});
          this.setPollDone({pollDone: false});
          this.disable = false;
        }
      },
    async startPoll(data) {
      this.disable = true;
      if(this.getMa !== data.idMedicionAsignada) {
        const urlPdf = await this.setUrlPDF({
          idMedicion: data.medicionTO.idMedicion,
        });
        if (urlPdf.status === 200) {
          this.setPoll({ poll: data });
          this.setQuantityQuestions({
            quantityQuestions: data.medicionTO.quantityQuestions,
          });
          this.setMa({idMedicionAsignada: data.idMedicionAsignada});
          this.setQuestions({ questions: data.medicionTO.form.questions });
          await this.$router.push({path: `/encuesta/${data.idMedicionAsignada}`});
          this.setPollDone({pollDone: false});
          this.disable = false;
          this.setLoadedPdf({loadedPdf: false})
          this.setCarouselIndex({ carouselIndex:  0 });
        } else {
          this.noAvailable = true;
          this.positionMessage = "top";
          this.message = `<h1>Pdf encuesta ${data.medicionTO.code} no encontrada.</h1><h1>Contáctese con soporte Roma: +56 9 3458 0660</h1>`;
          this.disable = false;
        }
      } else{
        await this.$router.push({path: `/encuesta/${data.idMedicionAsignada}`});
        this.setPollDone({pollDone: false});
        this.setLoadedPdf({loadedPdf: false})
        this.setCarouselIndex({ carouselIndex:  0 });
        this.disable = false;
      }
    },
  },
};
</script>

<style lang="scss">
$card_y_margin: 35px;

button.v-btn[disabled] {
  opacity: 1 !important;
  color: #3a8fce;
  background-color: rgba(255,255,255,.12)!important;
}

.roma-card-inline {
  max-height: 280px;
  &__img-card {
    width: auto;
    height: 100%;
  }
  .card-header {
    &__code {
      font-size: 14px;
      color: #afafaf;
    }
    &__state {
      font-size: 16px;
      color: #3a8fce;
    }
  }
  .btn-start {
    border-radius: 10px;
    position: absolute;
    bottom: 30px;
    right: 30px;
    padding: 15px 10px !important;
    width: 180px;
    height: 50px !important;
    font-size: 17px !important;
    background-color: #e97c21 !important;
    color: #ffffff !important;
    box-shadow: none !important;
  }

  .btn-disable {
    border-radius: 10px;
    position: absolute;
    bottom: 30px;
    right: 30px;
    padding: 15px 10px !important;
    width: 180px;
    height: 50px !important;
    font-size: 17px !important;
    background-color: rgba(0,0,0, 0.12);
    color: rgba(0,0,0,.26);
    box-shadow: none !important;
  }


  @media (max-width: 800px) {
    .btn-start {
      border-radius: 0;
      position: absolute;
      bottom: 7px;
      right: 5px;
      padding: 2px !important;
      width: 100px;
      height: 50px !important;
      font-size: 16px !important;
      background-color: transparent !important;
      color: #3a8fce !important;
      box-shadow: none !important;
    }
    .btn-disable {
      border-radius: 0;
      position: absolute;
      bottom: 7px;
      right: 5px;
      padding: 2px !important;
      width: 100px;
      height: 50px !important;
      font-size: 16px !important;
      background-color: transparent !important;
      color: rgba(0,0,0,.26);
      box-shadow: none !important;
    }
  }
  @media (max-width: 599px) {
    max-height: 100% !important;
    height: auto !important;
  }
}
</style>
